var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { attrs: { "no-margin": "" } },
    [
      _c(
        "w-col",
        { attrs: { xs: "12", "no-margin": "" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(_vm._s(_vm.$ct("page-settings"))),
                      ]),
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "6" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      min: 10,
                                      max: 10000,
                                      label: _vm.$ct("width-mm"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.layout.PageSettings.Width,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.layout.PageSettings,
                                          "Width",
                                          $$v
                                        )
                                      },
                                      expression: "layout.PageSettings.Width",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "6" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      min: 10,
                                      max: 10000,
                                      label: _vm.$ct("height-mm"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.layout.PageSettings.Height,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.layout.PageSettings,
                                          "Height",
                                          $$v
                                        )
                                      },
                                      expression: "layout.PageSettings.Height",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          !_vm.useCustomFormat
                            ? _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12" } },
                                    [
                                      _c("w-select", {
                                        attrs: {
                                          fancy: "",
                                          value: _vm.selectedFormat,
                                          label: _vm.$ct("page-format"),
                                          items: _vm.pageFormatItems,
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.setFormat($event)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12" } },
                                    [
                                      _c(
                                        "w-link",
                                        {
                                          style: { userSelect: "none" },
                                          on: {
                                            click: function ($event) {
                                              _vm.useCustomFormat = true
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$ct("use-custom-page-format")
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "6" } },
                                    [
                                      _c("w-input-number", {
                                        attrs: {
                                          min: _vm.minPageWidth,
                                          max: 10000,
                                          label: _vm.$ct("page-width-mm"),
                                          fancy: "",
                                        },
                                        model: {
                                          value:
                                            _vm.layout.PageSettings.PageWidth,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.layout.PageSettings,
                                              "PageWidth",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "layout.PageSettings.PageWidth",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "6" } },
                                    [
                                      _c("w-input-number", {
                                        attrs: {
                                          min: _vm.minPageHeight,
                                          max: 10000,
                                          label: _vm.$ct("page-height-mm"),
                                          fancy: "",
                                        },
                                        model: {
                                          value:
                                            _vm.layout.PageSettings.PageHeight,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.layout.PageSettings,
                                              "PageHeight",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "layout.PageSettings.PageHeight",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12" } },
                                    [
                                      _c(
                                        "w-link",
                                        {
                                          style: { userSelect: "none" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.useDefaultFormat()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$ct("use-default-page-format")
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "6" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      min: 1,
                                      max: 50,
                                      decimals: 0,
                                      label: _vm.$ct("labels-per-row"),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.layout.PageSettings.LabelsPerRow,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.layout.PageSettings,
                                          "LabelsPerRow",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "layout.PageSettings.LabelsPerRow",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "6" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      min: 1,
                                      max: 50,
                                      decimals: 0,
                                      label: _vm.$ct("rows-per-page"),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.layout.PageSettings.RowsPerPage,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.layout.PageSettings,
                                          "RowsPerPage",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "layout.PageSettings.RowsPerPage",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "6" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      min: 0,
                                      label: _vm.$ct("horizontal-spacing"),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.layout.PageSettings
                                          .HorizontalSpacing,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.layout.PageSettings,
                                          "HorizontalSpacing",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "layout.PageSettings.HorizontalSpacing",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "6" } },
                                [
                                  _c("w-input-number", {
                                    attrs: {
                                      min: 0,
                                      label: _vm.$ct("vertical-spacing"),
                                      fancy: "",
                                    },
                                    model: {
                                      value:
                                        _vm.layout.PageSettings.VerticalSpacing,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.layout.PageSettings,
                                          "VerticalSpacing",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "layout.PageSettings.VerticalSpacing",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-margin-edit", {
                    attrs: {
                      value: _vm.layout.PageSettings.Margin,
                      title: _vm.$ct("margins"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }